module.exports = __webpack_public_path__ + "img/img-avatar-04.9c00258b.png";